module.exports = __webpack_public_path__ + "ab95f4225d483d4c7f1df5eeb03f96e9.pdf";